import React from 'react';
import { Button, Dialog, DialogActions, DialogTitle, FormControl } from '@mui/material';

// Styles
import { CustomDialogContent, Title } from './styles';
import { ColorsContext } from "../../Context/ColorsContext"

// Utils
import { useTranslation } from 'react-i18next'
import { CustomButtonV2 } from '../../pages/styles';
import { MapRounded } from '@mui/icons-material';

export const ChildrenDialog = (props) => {
    const {openDialog, title, instanceCode, isPlotPlanView, handleCloseDialog, children} = props;
    const { t } = useTranslation();
    const { colors } = React.useContext(ColorsContext);

    return (
        <Dialog
            open={openDialog}
            onClose={() => handleCloseDialog(false)}
            maxWidth="md"
            fullWidth={true}
            PaperProps={{
                sx: isPlotPlanView ? 
                  { height: '85vh', display: 'flex', flexDirection: 'column', borderRadius: '10px' } : 
                  { borderRadius: '10px' }
            }}
        >
            <DialogTitle>
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
					<MapRounded sx={{color: colors.sidebarSelectColor}}/>
                    <Title mx={1}>
                        {title}
                    </Title>
                    <Title isCode={true}>
                        {instanceCode}
                    </Title>
                </div>
            </DialogTitle>
            <CustomDialogContent dividers sx={isPlotPlanView ? { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '10px' } : {}}>
                {children}
            </CustomDialogContent>
            <DialogActions>
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'end'}}>
				<div style={{ display: 'flex', width: '50%' }}></div>
                <CustomButtonV2
                    onClick={() => handleCloseDialog(false)}
                >
                   {t('common.close')}
                </CustomButtonV2>
              </div>
            </DialogActions>
        </Dialog>
    )
}
